import * as actions from './ContextualSidebarActions';

/**
 * null = use default based on externalHost (derived from infoSelector).
 * boolean = user has explicitly toggled the sidebar.
 */
const initialState = {
  isCollapsed: null,
};

export default (state = initialState, { type, ...action }) => {
  switch (type) {
    case actions.SET_IS_COLLAPSED:
      return { ...state, isCollapsed: action.isCollapsed };
    default:
      return state;
  }
};
